module.exports = __webpack_public_path__ + "img/14.242bb786.jpg";